// HOOKS
import { useParams, Link } from "react-router-dom";
import { useContext, useEffect, useState } from "react";

// CONTEXT
import { ProductsContext } from "../../context/products.context.jsx";

const Page = () => {
  const {
    getProducts,
    getModels,
    products: productsContext,
  } = useContext(ProductsContext);
  const { category, make, model } = useParams();
  const [products, setProducts] = useState([]);
  const [similarModels, setSimilarModels] = useState([]);
  useEffect(() => {
    setProducts(getProducts(category, make, model));
    setSimilarModels(
      getModels(category, make)?.filter((m) => m.name.toLowerCase() !== model)
    );
  }, [category, make, model, productsContext]);

  return (
    <section className="w-screen items-center flex flex-col px-8 py-8 gap-8">
      <p>
        If you don't see your device listed, please call us at 913-717-7779 for
        a custom quote.
      </p>
      <div className="w-full flex flex-row justify-center gap-8">
        <div className="flex flex-col gap-2 items-center">
          <div className="shadow-md shadow-black max-w-[150px] max-h-[150px] flex justify-center items-center m-4 p-2 text-wrap text-center bg-secondary text-white font-medium text-lg aspect-square">{`${products[0]?.category} ${products[0]?.make} ${products[0]?.model}`}</div>
          <div className="flex flex-col items-center">
            <p className="font-medium border-b-2 border-black">
              Other {`${products[0]?.make} ${products[0]?.category} Models`}
            </p>
            {similarModels?.map((model) => (
              <Link
                key={model.name}
                to={model.link}
                className="hover:underline"
              >
                {model.name}
              </Link>
            ))}
          </div>
        </div>
        <div className="flex flex-col">
          <h2 className="font-medium text-xl px-8">{`${products[0]?.category} ${products[0]?.make} ${products[0]?.model}`}</h2>
          <div className="flex flex-col">
            <div className="px-2 font-medium flex flex-row justify-between border-b-2 border-black">
              <p>Service</p>
              <p>Price</p>
            </div>
            <div className="flex flex-col">
              {products?.map((product) => (
                <div
                  key={product.name}
                  className="flex flex-row justify-between"
                >
                  <p>{product.external_description}</p>
                  <p>${product.retail_price}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Page;
